import axiosClient from './axiosClient';

const EmployeesReviewApi = {
  /**
   * Create or update a review
   * @param {object} data - {
   *   month: string,
   *   year: number,
   *   user_id: number,
   *   employee_review?: {
   *     rating: Array<{ id: number, value: number }>,
   *     feedback: Record<string, string>
   *   },
   *   manager_review?: { ... },
   *   hr_review?: { ... },
   *   status?: 'draft' | 'Manager Review' | 'HR Review' | 'Completed'
   * }
   */
  create: (data) => {
    return axiosClient.post('/api/review/createReview', data);
  },

  /**
   * Get review by ID
   * @param {{ month: string, year: number, user_id: number }} data - { month, year, user_id }
   */
  getByDate: (data) => {
    return axiosClient.post('/api/review/getReview', data);
  },

  /**
   * Get all reviews for a user
   * @param {{ month: string, year: number }} data - { month, year, user_id }
   */
  getAllUserReviews: (data) => {
    return axiosClient.post('/api/review/getAllUserReviews', data);
  },

  updateManagerReviewRatings: (data) => {
    return axiosClient.post('/api/review/updateManagerReviewRatings', data);
  },
};

export default EmployeesReviewApi;
